<template>
  <g>
    <path
      d="M18.2 1.00024H9.8C8.81 1.00024 8 1.81024 8 2.80024V17.2002C8 18.1902 8.81 18.9902 9.8 18.9902L18.2 19.0002C19.19 19.0002 20 18.1902 20 17.2002V2.80024C20 1.81024 19.19 1.00024 18.2 1.00024ZM14 3.00024C15.1 3.00024 16 3.89024 16 5.00024C16 6.11024 15.1 7.00024 14 7.00024C12.9 7.00024 12 6.11024 12 5.00024C12 3.89024 12.9 3.00024 14 3.00024ZM14 16.5002C11.79 16.5002 10 14.7102 10 12.5002C10 10.2902 11.79 8.50024 14 8.50024C16.21 8.50024 18 10.2902 18 12.5002C18 14.7102 16.21 16.5002 14 16.5002Z"
    />
    <path
      d="M14 15.0002C15.3807 15.0002 16.5 13.881 16.5 12.5002C16.5 11.1195 15.3807 10.0002 14 10.0002C12.6193 10.0002 11.5 11.1195 11.5 12.5002C11.5 13.881 12.6193 15.0002 14 15.0002Z"
    />
    <path
      d="M5 5.00024C4.45 5.00024 4 5.45024 4 6.00024V21.0002C4 22.1002 4.89 23.0002 6 23.0002H15C15.55 23.0002 16 22.5502 16 22.0002C16 21.4502 15.55 21.0002 15 21.0002H7C6.45 21.0002 6 20.5502 6 20.0002V6.00024C6 5.45024 5.55 5.00024 5 5.00024Z"
    />
  </g>
</template>
